import { ROLE_LABELS, type SubscriptionStatus, type TenantRole } from '@provalia/shared';
import type { Tone } from '../shared/ui';
import type { OutboxStatus } from './types';

export const SUBSCRIPTION_LABELS: Record<SubscriptionStatus, string> = {
  prueba: 'En prueba',
  activo: 'Activo',
  suspendido: 'Suspendido',
};

export const SUBSCRIPTION_TONES: Record<SubscriptionStatus, Tone> = {
  prueba: 'info',
  activo: 'ok',
  suspendido: 'bad',
};

export const OUTBOX_LABELS: Record<OutboxStatus, string> = {
  pending: 'Pendiente',
  sent: 'Enviado',
  failed: 'Fallido',
  skipped: 'Omitido',
};

export const OUTBOX_TONES: Record<OutboxStatus, Tone> = {
  pending: 'info',
  sent: 'ok',
  failed: 'bad',
  skipped: 'neutral',
};

const MAIL_KINDS: Record<string, string> = {
  'order.new': 'Pedido nuevo',
  'order.reminder': 'Recordatorio',
  'order.modified': 'Pedido modificado',
  'order.rejected': 'Pedido rechazado',
  'date.review': 'Fecha a revisar',
  'price.review': 'Precio a revisar',
  'weekly.digest': 'Resumen semanal',
  test: 'Correo de prueba',
};

export const mailKindLabel = (kind: string): string => MAIL_KINDS[kind] ?? kind;

const ACTIONS: Record<string, string> = {
  // Portal del cliente
  'order.publish': 'Pedido publicado',
  'order.accept': 'Pedido aceptado',
  'order.reject': 'Pedido rechazado',
  'order.modified': 'Pedido modificado en SAP',
  'dates.propose': 'Fechas propuestas',
  'delivery_note.submit': 'Albarán enviado',
  'supplier.enable': 'Proveedor habilitado',
  'supplier.update': 'Proveedor actualizado',
  'supplier.logo': 'Logo de proveedor',
  // Registro de ECINSA
  'tenant.create': 'Alta de cliente',
  'tenant.update': 'Conexión modificada',
  'tenant.subscription': 'Suscripción modificada',
  'tenant.branding': 'Marca modificada',
  'tenant.logo': 'Logo subido',
  'tenant.logo.remove': 'Logo quitado',
  'tenant.delete': 'Cliente borrado',
  'company.create': 'Alta de sociedad',
  'company.update': 'Sociedad modificada',
  'company.delete': 'Sociedad borrada',
  'udf.install': 'Campos U_EDI_ creados',
  'user.create': 'Alta de usuario',
  'user.update': 'Usuario modificado',
  'user.delete': 'Usuario borrado',
  'user.reset_password': 'Contraseña regenerada',
  'settings.update': 'Configuración guardada',
};

export const actionLabel = (action: string): string => ACTIONS[action] ?? action;

export function roleLabel(role: string | null | undefined): string {
  if (!role) return '—';
  return (ROLE_LABELS as Record<string, string>)[role as TenantRole] ?? (role === 'admin' ? 'ECINSA' : role);
}

export const UDF_TABLE_LABELS: Record<string, string> = {
  OPOR: 'Cabecera del pedido',
  POR1: 'Líneas del pedido',
  OCRD: 'Proveedor',
};
